import script from "./VisualisasiWayang.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualisasiWayang.vue?vue&type=script&setup=true&lang=js"

import "./VisualisasiWayang.vue?vue&type=style&index=0&id=6f55b3f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f55b3f8"]])

export default __exports__